import MainContent from 'Components/Layout/MainContent'
import UnauthenticatedMenuBar from 'Components/Layout/UnauthenticatedMenuBar'
import Box from '@mui/material/Box'
import type React from 'react'
import { Outlet } from 'react-router-dom'

interface LayoutProps {
  children?: React.ReactNode
}

const UnauthenticatedLayout = ({ children }: LayoutProps) => {
  return (
    <Box>
      <UnauthenticatedMenuBar />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1
        }}
      >
        <MainContent>{children ?? <Outlet />}</MainContent>
      </Box>
    </Box>
  )
}

export default UnauthenticatedLayout
